<template>
  <b-card v-if="totals" class="mb-1">
    <b-row>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-info" class="mb-50">Ведущим</b-badge>
        <h4 class="mb-0">{{ formatRub(totals.host) }}</h4>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-warning" class="mb-50">Авторам</b-badge>
        <h4 class="mb-0">{{ formatRub(totals.author) }}</h4>
      </b-col>
      <b-col cols="6" md="3" class="text-center">
        <b-badge variant="light-secondary" class="mb-50">Фиксированные</b-badge>
        <h4 class="mb-0">{{ formatRub(totals.fixed) }}</h4>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-primary" class="mb-50">Прочее</b-badge>
        <h4 class="mb-0">{{ formatRub(totals.extra) }}</h4>
      </b-col>
      <b-col cols="6" md="3" class="text-center">
        <b-badge variant="light-danger" class="mb-50">Итого</b-badge>
        <h4 class="mb-0 text-danger">{{ formatRub(totals.grand) }}</h4>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BBadge } from 'bootstrap-vue'
import { formatRub } from '@/views/finance/utils'

export default {
  components: { BCard, BRow, BCol, BBadge },
  props: {
    totals: { type: Object, default: null },
  },
  setup() {
    return { formatRub }
  },
}
</script>
